module.exports = __webpack_public_path__ + "img/foodworks-logo.2efc0cb9.png";